// removed by extract-text-webpack-plugin
module.exports = {"prevPage":"prevPage-3wjSB","nextPage":"nextPage-3PHPt","disabled":"disabled-HKXHC","not-valid":"not-valid-2KseG","notValid":"not-valid-2KseG","formControl":"formControl-3Xl1H","easPagination":"easPagination-3pZW0","cmn-total-pages":"cmn-total-pages-M0wJz","cmnTotalPages":"cmn-total-pages-M0wJz"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/table/table-pager/table-pager/styles.less
 ** module id = 194
 ** module chunks = 0
 **/